<template>
  <div v-if="$store.state.notification.newAlertRules" class="container-alert">
    <McAlert
      class="custom-alert"
      variant="info"
      :withGap="false"
      withIcon
      hasClose
      @close="clearNewAlertRulesToast"
    >
      <template #label>
        <div class="mc-alert__text">
          <span>{{ $t('dashboard.text.newNotification') }}</span>
          <a
            href="/setting/notification"
            target="_blank"
            class="text-primary text-decoration-underline"
          >
            {{ $t('dashboard.text.seeHere') }}
          </a>
        </div>
      </template>
    </McAlert>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import McAlert from '@/components/McAlert'

export default {
  components: { McAlert },
  methods: {
    ...mapActions({
      clearNewAlertRulesToast: 'notification/clearNewAlertRulesToast',
    }),
  },
}
</script>

<style lang="scss" scoped>
.container-alert {
  margin-top: -25px;
  margin-bottom: 20px;
}

.custom-alert {
  border: 0 !important;
  border-radius: 0;
}
</style>
